import { apiRequest } from '../api';
import { WCA_SETTINGS } from '../endPoints';

/* ================= CALL SETTINGS ================= */

export const WCA_GET_CALL_SETTINGS = (metadataid) => {
  return apiRequest('get', WCA_SETTINGS.GET_CALL_SETTINGS(metadataid));
};

export const WCA_SET_CALL_SETTINGS = (metadataid, data) => {
  return apiRequest('post', WCA_SETTINGS.SET_CALL_SETTINGS(metadataid), data);
};

/* ================= WHATSAPP PROFILE ================= */

export const WCA_GET_WHATSAPP_PROFILE = (metadataid) => {
  return apiRequest('get', WCA_SETTINGS.GET_WHATSAPP_PROFILE(metadataid));
};

export const WCA_SET_WHATSAPP_PROFILE = (metadataid, data) => {
  return apiRequest('post', WCA_SETTINGS.SET_WHATSAPP_PROFILE(metadataid), data);
};

export const WCA_UPLOAD_PROFILE_PICTURE = (metadataid, formData) => {
  return apiRequest('post', WCA_SETTINGS.UPLOAD_PROFILE_PICTURE(metadataid), formData);
};
